import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Nav from './Nav';
import StudentSidebar from './StudentSidebar';

const StudentLayout = ({ children }) => {
    const { isLoggedIn } = useAuth();
    const [showStudentNavbar, setShowStudentNavbar] = useState(false);

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Navbar */}
            <Nav setShowStudentNavbar={setShowStudentNavbar} />

            {/* Mobile overlay sidebar */}
            {showStudentNavbar && (
                <StudentSidebar onClose={() => setShowStudentNavbar(false)} />
            )}

            {/* Main Content */}
            <main className="pt-16 min-h-screen transition-all duration-300">
                {children}
            </main>
        </div>
    );
};

export default StudentLayout;
